import fetchSitesData from './fetch-sites-data';

export default {
  fetchSitesData,
};
